import { render } from "./MetadataCard.vue?vue&type=template&id=27f1c43a&scoped=true&ts=true"
import script from "./MetadataCard.vue?vue&type=script&lang=ts"
export * from "./MetadataCard.vue?vue&type=script&lang=ts"

import "./MetadataCard.vue?vue&type=style&index=0&id=27f1c43a&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f1c43a"]])

export default __exports__